import { LogLevel } from '@grafana/faro-web-sdk';
import { UpdateBoardSettingsRequest } from '../../../api/core/models/api/update-board-settings-request';
import { MeasurementSystem } from '../../../model/enums/measurement-system';
import { LoggingService } from '../../logging.service';

export function measurementSystemToApiMeasurementSystem(
  loggingService: LoggingService,
  measurementSystem?: MeasurementSystem
): UpdateBoardSettingsRequest['defaultMeasurementSystem'] {
  if (measurementSystem === undefined || measurementSystem === null) {
    loggingService.logMessage('Board is missing measurement system, setting it to "METRIC"', undefined, LogLevel.WARN);
  }
  if (measurementSystem === MeasurementSystem.USCustomaryUnits || measurementSystem === MeasurementSystem.Imperial) {
    return 'IMPERIAL';
  }
  return 'METRIC';
}
